module.exports = __webpack_public_path__ + "img/adfs.61d2c963.svg";